import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7bda7354"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-card p-shadow-2 p-text-bold p-p-3 p-text-center p-text-uppercase" }, " Point de vente ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.2em","line-height":"1.5em"} }, " Le POS est l’interface utilisée par le caissier au point de vente. Il permet de créer des ventes payées ou à crédit, imprimer des reçus, faire des décaissements pour faire une dépense. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: `background-image: url('/pos.PNG')`,
  class: "image main-image p-my-3"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Journée vs séquence", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " En général, une caisse est ouverte le matin et fermée la nuit à la fermeture de la boutique. Quand on ferme la caisse, on a un rapport de fermeture qui est généré et qui peut être imprimé sur un ticket. Ce rapport va donner des détails sur la journée qui vient de finir comme par exemple : Les ventes du jours, les ventes par catégories, les ventes à crédits, les crédits payés, les dépenses et le solde que l’on devrait retrouver dans la caisse. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Mais ici, on a une approche légèrement différente. En fait la seule différence c’est qu’au lieu de parler de « journée » on va parler de « séquence ». Au lieu de commencer une journée et terminer une journée, on commence une séquence et termine une séquence. ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Soit au lieu de début de journée et fin de journée on parle plutôt d’ouverture de séquence et fermeture de séquence. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Les sctions du POS", -1))
const _hoisted_9 = { class: "p-grid p-mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-md-6 p-p-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"max-width":"100%"},
    src: "/section_pos.PNG"
  })
], -1))
const _hoisted_11 = { class: "p-col-12 p-md-6 p-p-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Section Menu", -1))
const _hoisted_13 = {
  role: "list",
  class: "content-list"
}
const _hoisted_14 = { class: "p-grid p-mt-4" }
const _hoisted_15 = { class: "p-col-12 p-md-6 p-p-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "p-mt-6" }, "Section ticket :", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Le champ client est un champ qui proposera de sélectionner un client dans la liste de vos clients. Le champ client n’est pas obligatoire. Si aucun client n’est sélectionné, la vente sera enregistrée automatiquement au nom du client « Au comptoir ». Si le ticket est mis à crédit, le champ client sera obligatoire. Le bouton remise présenté par le signe du pourcentage permet de faire une remise sur le total. Quand le caissier clique dessus, il a deux champs : Pourcentage de la remise, Valeur de la remise. ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-md-6 p-p-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/ticket.PNG",
    style: {"max-width":"100%"}
  })
], -1))
const _hoisted_19 = { class: "p-d-flex p-justify-center p-pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createTextVNode(" On a les boutons suivants : "),
        _createElementVNode("ol", _hoisted_13, [
          _createElementVNode("li", null, [
            _createVNode(_component_Chip, { label: "Retour" }),
            _createTextVNode(" : Permet de retourner au tableau de bord. Cela ne signifie pas que l’on a fermé la séquence. ")
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Chip, { label: "Produits" }),
            _createTextVNode(" : Ici on affiche les catégories et produits. Les produits sont cliquables. Quand on clique dessus, le produit est ajouté au ticket. ")
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Chip, { label: "Crédits" }),
            _createTextVNode(" : Affiche la liste des tickets à crédits. Quand on clique sur un ticket, il est affiché dans la section ticket et on peut alors choisir de le payer, l’imprimer ou de le remettre à crédit. ")
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Chip, { label: "Tickets en attente" }),
            _createTextVNode(" : La liste des tickets en attente. Quand on clique dessus, on le récupère dans la section ticket. ")
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Chip, { label: "Dépenses" }),
            _createTextVNode(" : Le caissier à la possibilité de rajouter une dépense en renseignant les informations : Motif de la dépense et Montant. ")
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Chip, { label: "Clôture" }),
            _createTextVNode(" : Permet de fermer la séquence en cours. Un rapport est généré dans la section Content et il peut être imprimé. ")
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_Chip, { label: "Plein écran" }),
            _createTextVNode(" : Permet d'agrandir votre ecran de pos à taille maximale. ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("p", null, [
          _createTextVNode(" Le bouton "),
          _createVNode(_component_Button, {
            icon: "pi pi-trash",
            class: "p-button-danger"
          }),
          _createTextVNode(" permet de supprimer le ticket en cours. ")
        ])
      ]),
      _hoisted_18
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_Button, {
        style: {"min-width":"50%"},
        label: "Passer à la section suivante",
        class: "p-button-warning p-shadow-4 p-py-3 p-button-rounded",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/documentation/rapport')))
      })
    ])
  ], 64))
}